import axios from 'axios'
import { getAPIUrl } from '../API'

export const getBridgingApprovalStatus = async () => {
  const { data } = await axios.get(
    `${getAPIUrl()}/Disclaimer/acceptance-status?disclaimerName=BridgingFinance`,
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
      },
    },
  )
  return data.data
}
